import React, { useEffect, useState } from 'react';
import { Container, Button, Modal, Row } from 'react-bootstrap';
import heroBg from '../assets/images/HeroBanner.png';
import '../styles/AcotProfessionalAdvancement.css';
import { useNavigate } from 'react-router-dom';
import { X } from 'lucide-react';

const ProfessionalAdvancement = () => {
  const navigate = useNavigate();
  const [selectedPdf, setSelectedPdf] = useState(null);
  const [showPdfModal, setShowPdfModal] = useState(false);
  const [tokenState, setTokenState] = useState(localStorage.getItem("token"));

  const handleMemberLogin = () => {
    navigate("/member-login");
  };

  const handleEdcclogin = () => {
    navigate("/edcc-login");
  };

  // Handle webinar card click to open PDF in viewer
  const handleWebinarClick = (pdfUrl) => {
    setSelectedPdf(pdfUrl);
    setShowPdfModal(true);
  };

  // Close PDF modal
  const handleClosePdfModal = () => {
    setShowPdfModal(false);
    setSelectedPdf(null);
  };

    const handleInterestClick = () => {
    navigate("/professional-advancement-form");
    window.scrollTo(0, 0); // Reset scroll before navigating
  }

  useEffect(() => {
    const interval = setInterval(() => {
      const currentToken = localStorage.getItem("token");
      if (currentToken !== tokenState){
        setTokenState(currentToken);
      }
    }, 500);
    return () => clearInterval(interval);
  }, [tokenState]);

  return (
    <>
      {/* Fixed Hero Section */}
      <section
        className="hero-fixed"
        style={{ backgroundImage: `url(${heroBg})` }}>

        <div className="hero-scroll-content">
          <div className="hero-content-home poppins-regular">
            <h1 className="hero-heading">All India Occupational Therapists' Association</h1>
              {!tokenState && (
                <div className="hero-buttons">
                <button className="glass-button" onClick={handleMemberLogin}>
                  Member Login
                </button>
                <button className="glass-button" onClick={handleEdcclogin}>
                  Ergonomic Certificate login
                </button>
              </div>
              )}
          </div>
        </div>
      </section>

      {/* Scrollable Content Container */}
      <div className="scrollable-content-home">
        <div className="content-container">
          <section className="professional-advance-content-section">
            <Container>
              <h1 className="section-title-professional-advance poppins-medium">
                Professional Advancement
              </h1>

              <p className="content-text poppins-regular">
                The Indian Psychiatric Society Western Zonal Branch (IPS WZB),
                through its Child Psychiatry Sub-Committee, is organizing a
                multidisciplinary webinar in collaboration with leading
                associations including the Psychologists Collective, Indian
                Association of Physiotherapists (and its Women Cell), Indian
                Speech-Language & Hearing Association, and the All India
                Occupational Therapists' Association.
              </p>

              <div className="webinar-cards">
                <div className="webinar-card" onClick={() => handleWebinarClick('https://aiota.org/temp/updates/05MAY2024-MULTIDISCIPLINARY%20TEAMS%20IN%20CHILD%20AND%20ADOLESCENT%20MENTAL%20HEALTH-%20PART%20II.V6.pdf')}>
                  <span className="material-symbols-outlined webinar-icon-larger">
                    psychology_alt
                  </span>
                  <a href="#" className="webinar-arrow-link" title="Learn More" onClick={(e) => e.preventDefault()}>
                    <span className="material-symbols-outlined webinar-arrow">arrow_upward</span>
                  </a>
                  <div className="webinar-content">
                    <h3 className="webinar-title poppins-medium">
                      Webinar on Multidisciplinary Teams in Child and Adolescent
                      Mental Health – Part 2
                    </h3>
                  </div>
                </div>

                <div className="webinar-card" onClick={() => handleWebinarClick('https://aiota.org/temp/updates/3rd%20Webinar%20Multidisciplinary%20teams%20in%20child%20and%20adolescent%20mental%20health.V1.pdf')}>
                  <span className="material-symbols-outlined webinar-icon-larger">
                    psychology_alt
                  </span>
                  <a href="#" className="webinar-arrow-link" title="Learn More" onClick={(e) => e.preventDefault()}>
                    <span className="material-symbols-outlined webinar-arrow">arrow_upward</span>
                  </a>
                  <div className="webinar-content">
                    <h3 className="webinar-title poppins-medium">
                      Webinar on Multidisciplinary Teams in Child and Adolescent
                      Mental Health – Part 3
                    </h3>
                  </div>
                </div>
              </div>
              <p className="content-text poppins-regular">
                To assist us in comprehending your interest in pursuing the
                courses listed below, kindly complete the form located at the
                bottom of this page. This will aid us in assessing the viability
                of arranging the courses and in delivering the most up-to-date
                information to our members regarding the commencement of the
                courses.
              </p>
              <div style={{ textAlign: "center" }}>
                <button className="registers-button interest-button poppins-medium" onClick={handleInterestClick}>
                  <span className="interest-icon material-symbols-outlined">
                    contract_edit
                  </span>
                  SHOW YOUR INTEREST
                </button>
              </div>

              <br />
              <br />
              <ul className="course-list poppins-medium">
                <li className="course-item">
                    Fellowship in Advanced Occupational Therapy – 36 weeks –
                    Part 1 and 3 online and part 2 offline.
                </li>
                <li className="course-item">
                  
                    Physical Agent Modalities adjunct to Occupational Therapy –
                    3 full day course – offline only
                </li>
                <li className="course-item">
                  
                    Ergonomics – Office, School and Home – 3 full day course –
                    Hybrid
                </li>
                <li className="course-item">
                  
                    Driver Rehab – 2 Full day course – Offline only
                </li>
                <li className="course-item">
                  
                    Wheelchair Seating and mobility – 1 Day Course – Offline
                </li>
                <li className="course-item">
                  SID Certification Course – 1 Day – Hybrid
                </li>
                <li className="course-item">
                  
                    Clinical CBT and REBT in OT Mental Health Practice – 2-day
                    offline course
                </li>
                <li className="course-item">
                  
                    Clinical Apllication of Narrative Practice in OT-2-day
                    offline course
                </li>
                <li className="course-item">
                  Assistive Technology - 1 day- Hybrid Course
                </li>
                <li className="course-item">
                  
                    Certificate Course in 'Occupational Therapy in NICU' - 3 day
                    offline course
                </li>
                <li className="course-item">
                  Assistive Technology -1 Day Hybrid Course
                </li>
                <li className="course-item">
                  
                    Competency Based Curriculum for OT Education (only for
                    faculty) - 2 day offline workshop
                </li>
                <li className="course-item">
                  
                    Introduction to DIR and DIR floor time courses for
                    peadiatric occupational therapists - 15 hours online program
                    by the International Council on Developement and Learning
                </li>
              </ul>
            </Container>
          </section>
        </div>
      </div>

      {/* PDF Viewer Modal */}
      <Modal 
        show={showPdfModal} 
        onHide={handleClosePdfModal} 
        size="xl" 
        centered
        className="pdf-viewer-modal"
      >
        <Modal.Header className="d-flex justify-content-between align-items-center">
          <Modal.Title>Webinar Details</Modal.Title>
          <Button 
            variant="outline-secondary" 
            onClick={handleClosePdfModal}
            className="close-btn"
          >
            <X size={24} />
          </Button>
        </Modal.Header>
        <Modal.Body className="p-0">
          {selectedPdf && (
            <div className="pdf-viewer-container">
              <iframe
                src={selectedPdf}
                title="Webinar PDF"
                width="100%"
                height="600px"
                frameBorder="0"
                allowFullScreen
              />
            </div>
          )}
        </Modal.Body>
        <Modal.Footer className="d-flex justify-content-center justify-content-sm-between">
            <Button 
              variant="primary" 
              onClick={() => window.open(selectedPdf, '_blank')}
              className='w-auto'
            >
              Open in New Tab
            </Button>
            <Button variant="secondary" onClick={handleClosePdfModal} className='w-auto mb-1'>
              Close
            </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default ProfessionalAdvancement;
